import React from "react";
import { Grid, Typography, Container, Avatar, CardMedia } from "@material-ui/core";
import { Images } from "salvatores";
import { ArrowBack, CameraAlt } from "@material-ui/icons";
import { CustomAppBar, CustomButton } from "../../../shared";
import { styleSheet } from "../../../assets/theme";
import { IDProofFrame } from "../../../assets/images";
import { getContent } from "../../../utils/helper";
import { supportedLanguageMapping } from "../../language/constants";
import {
   proofLabelMapping,
   proofRetakeMapping,
   proofCaptureMapping,
   proofSubmitMapping,
   proofCaptureBacksideMapping,
   PROOF_KEYS,
   PROOF_TYPE,
} from "../../../utils/constant";

const IdProof = ({
   goBack,
   goToScreen,
   language,
   languageJSON,
   captureImage,
   step,
   submit,
   selectedIdProofOption,
   handleChange,
   idProofFrontSide,
   idProofBackSide,
   saveIDProof,
   isCameraOn,
   idProofList,
}) => {
   return (
      <div>
         <CustomAppBar
            title={getContent(languageJSON, "title_id_proof")}
            leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
            rightButton={
               <CustomButton
                  variant="text"
                  color="primary"
                  handleChange={() => goToScreen("language", { to: "idProof" })}
                  label={supportedLanguageMapping[language]}
               />
            }
         />
         <Container style={{ height: "100vh", overflow: "auto", padding: "0px 0px 150px 0px" }}>
            {step === 1 ? (
               <Container>
                  <Grid container justify="center" spacing={2} style={{ maxHeight: "70vh", overflow: "scroll" }}>
                     <Grid item xs={11}>
                        <Typography>{getContent(languageJSON, "label_id_proof")}</Typography>
                     </Grid>
                     {idProofList.map((item, index) => (
                        <Grid key={index} item xs={6} md={3}>
                           <CardMedia
                              style={{ height: "15vh", width: "100%", backgroundSize: "contain" }}
                              image={item.image}
                              onClick={() => {
                                 handleChange("selectedIdProofOption", item);
                                 saveIDProof(item.value);
                              }}
                           >
                              <Grid container justify="center" alignItems="center" style={{ height: "100%" }}>
                                 <Grid
                                    item
                                    xs={11}
                                    style={{
                                       display: "flex",
                                       flexDirection: "column",
                                       justifyContent: "center",
                                       alignItems: "center",
                                    }}
                                 >
                                    <CameraAlt
                                       style={{
                                          color:
                                             selectedIdProofOption.value === item.value
                                                ? styleSheet.palette.primary.main
                                                : "#fff",
                                          width: 40,
                                          height: 40,
                                       }}
                                    />
                                    <Typography
                                       component="p"
                                       style={{
                                          color:
                                             selectedIdProofOption.value === item.value
                                                ? styleSheet.palette.primary.main
                                                : "#fff",
                                       }}
                                    >
                                       {item.label}
                                    </Typography>
                                 </Grid>
                              </Grid>
                           </CardMedia>
                        </Grid>
                     ))}
                  </Grid>
               </Container>
            ) : null}
            {step === 2 ? (
               [PROOF_TYPE.PAN].indexOf(selectedIdProofOption.value) > -1 ? (
                  <Container>
                     <Grid container justify="center" spacing={4} style={{ maxHeight: "100vh", overflow: "scroll" }}>
                        {idProofFrontSide ? (
                           <Grid item xs={10}>
                              <Avatar
                                 variant="square"
                                 src={idProofFrontSide}
                                 style={{ width: "100%", height: "40vh", objectFit: "contain" }}
                              />
                              <div style={{ margin: "5%" }}>
                                 <Images
                                    frameHeight={500}
                                    frame={IDProofFrame}
                                    title={getContent(
                                       languageJSON,
                                       proofRetakeMapping[selectedIdProofOption.value] || PROOF_KEYS.RETAKE_DL
                                    )}
                                    constraints={{
                                       audio: false,
                                       video: {
                                          facingMode: "environment",
                                       },
                                    }}
                                    cameraStateChange={(value) => handleChange("isCameraOn", value)}
                                    content={
                                       <CustomButton
                                          size="large"
                                          variant="contained"
                                          style={{ textAlign: "center", width: "100%" }}
                                          color="secondary"
                                          label={
                                             <Typography style={{ fontSize: 12 }}>
                                                {getContent(
                                                   languageJSON,
                                                   proofRetakeMapping[selectedIdProofOption.value] ||
                                                      PROOF_KEYS.RETAKE_DL
                                                )}
                                             </Typography>
                                          }
                                       />
                                    }
                                    captureImage={(image) => captureImage("idProofFrontSide", image)}
                                 />
                              </div>
                           </Grid>
                        ) : null}
                     </Grid>
                  </Container>
               ) : (
                  <Container>
                     <Grid container justify="center" spacing={4} style={{ maxHeight: "100vh", overflow: "scroll" }}>
                        {idProofFrontSide ? (
                           <Grid item xs={idProofBackSide ? 6 : 10}>
                              <Avatar
                                 variant="square"
                                 src={idProofFrontSide}
                                 style={{ width: "100%", height: "40vh", objectFit: "contain" }}
                              />
                              <div style={{ margin: "5%" }}>
                                 <Images
                                    frameHeight={500}
                                    frame={IDProofFrame}
                                    title={getContent(
                                       languageJSON,
                                       proofRetakeMapping[selectedIdProofOption.value] || PROOF_KEYS.RETAKE_DL
                                    )}
                                    subtitle={getContent(languageJSON, "label_front_side")}
                                    constraints={{
                                       audio: false,
                                       video: {
                                          facingMode: "environment",
                                       },
                                    }}
                                    cameraStateChange={(value) => handleChange("isCameraOn", value)}
                                    content={
                                       <CustomButton
                                          size="large"
                                          variant="contained"
                                          style={{ textAlign: "center", width: "100%", fontSize: 12 }}
                                          color="secondary"
                                          label={
                                             <Grid container alignItems="center" justify="center">
                                                <CameraAlt style={{ marginRight: 5 }} />
                                                <Typography style={{ fontSize: 12 }}>
                                                   {getContent(languageJSON, "action_retake_front_side")}
                                                </Typography>
                                             </Grid>
                                          }
                                       />
                                    }
                                    captureImage={(image) => captureImage("idProofFrontSide", image)}
                                 />
                              </div>
                           </Grid>
                        ) : null}
                        {idProofBackSide ? (
                           <Grid item xs={6}>
                              <Avatar
                                 variant="square"
                                 src={idProofBackSide}
                                 style={{ width: "100%", height: "40vh", objectFit: "contain" }}
                              />
                              <div style={{ margin: "5%" }}>
                                 <Images
                                    frameHeight={500}
                                    frame={IDProofFrame}
                                    title={getContent(
                                       languageJSON,
                                       proofRetakeMapping[selectedIdProofOption.value] || PROOF_KEYS.RETAKE_DL
                                    )}
                                    subtitle={getContent(languageJSON, "label_backside")}
                                    constraints={{
                                       audio: false,
                                       video: {
                                          facingMode: "environment",
                                       },
                                    }}
                                    cameraStateChange={(value) => handleChange("isCameraOn", value)}
                                    content={
                                       <CustomButton
                                          size="large"
                                          variant="contained"
                                          style={{ textAlign: "center", width: "100%", fontSize: 12 }}
                                          color="secondary"
                                          label={
                                             <Grid container alignItems="center" justify="center">
                                                <CameraAlt style={{ marginRight: 5 }} />
                                                <Typography style={{ fontSize: 12 }}>
                                                   {getContent(languageJSON, "action_retake_back_side")}
                                                </Typography>
                                             </Grid>
                                          }
                                       />
                                    }
                                    captureImage={(image) => captureImage("idProofBackSide", image)}
                                 />
                              </div>
                           </Grid>
                        ) : null}
                     </Grid>
                  </Container>
               )
            ) : null}
            {step === 1 && selectedIdProofOption ? (
               <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{
                     padding: "15px",
                     position: !isCameraOn ? "absolute" : "",
                     bottom: 0,
                     left: 0,
                     backgroundColor: "#f7fdfd",
                  }}
               >
                  <Grid item xs={11}>
                     <Images
                        frameHeight={500}
                        frame={IDProofFrame}
                        title={getContent(
                           languageJSON,
                           proofLabelMapping[selectedIdProofOption.value] || PROOF_KEYS.LABEL_DL
                        )}
                        subtitle={
                           [PROOF_TYPE.PAN].indexOf(selectedIdProofOption.value) === -1
                              ? getContent(languageJSON, "label_front_side")
                              : ""
                        }
                        constraints={{
                           audio: false,
                           video: {
                              facingMode: "environment",
                           },
                        }}
                        cameraStateChange={(value) => handleChange("isCameraOn", value)}
                        content={
                           <CustomButton
                              size="large"
                              variant="contained"
                              style={{ textAlign: "center", width: "100%" }}
                              color="primary"
                              label={
                                 <Grid container alignItems="center" justify="center">
                                    <CameraAlt style={{ marginRight: 5 }} />
                                    <Typography variant="button">
                                       {getContent(
                                          languageJSON,
                                          proofCaptureMapping[selectedIdProofOption.value] || PROOF_KEYS.CAPTURE_DL
                                       )}
                                    </Typography>
                                 </Grid>
                              }
                           />
                        }
                        captureImage={(image) => captureImage("idProofFrontSide", image)}
                     />
                  </Grid>
               </Grid>
            ) : null}
            {step === 2 &&
            ([PROOF_TYPE.PAN, PROOF_TYPE.OTHER].includes(selectedIdProofOption.value) || idProofBackSide) ? (
               <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{
                     padding: "15px",
                     position: "absolute",
                     bottom: 0,
                     left: 0,
                     backgroundColor: "#f7fdfd",
                     zIndex: 5,
                  }}
               >
                  <Grid item xs={11}>
                     <CustomButton
                        size="large"
                        variant="contained"
                        style={{ textAlign: "center", width: "100%" }}
                        color="primary"
                        label={
                           <Grid container alignItems="center" justify="center">
                              <Typography variant="button">
                                 {getContent(
                                    languageJSON,
                                    proofSubmitMapping[selectedIdProofOption.value] || PROOF_KEYS.SUBMIT_DL
                                 )}
                              </Typography>
                           </Grid>
                        }
                        handleChange={submit}
                     />
                  </Grid>
               </Grid>
            ) : null}
            {/* this condition is when id is aadhaar and not pan */}
            {step === 2 &&
            [PROOF_TYPE.PAN].indexOf(selectedIdProofOption.value) === -1 &&
            (([PROOF_TYPE.AADHAAR].indexOf(selectedIdProofOption.value) > -1 && !idProofBackSide) ||
               !idProofBackSide) ? (
               <Grid container justify="center" alignItems="center">
                  {[PROOF_TYPE.AADHAAR].indexOf(selectedIdProofOption.value) > -1 && !idProofBackSide ? (
                     <Grid item xs={11} style={{ padding: "2%" }}>
                        <Typography>{getContent(languageJSON, "text_capture_back_side")}</Typography>
                     </Grid>
                  ) : null}
                  <Grid item xs={11} style={{ padding: "2%" }}>
                     <Images
                        frameHeight={500}
                        frame={IDProofFrame}
                        title={getContent(
                           languageJSON,
                           proofLabelMapping[selectedIdProofOption.value] || PROOF_KEYS.LABEL_DL
                        )}
                        subtitle={getContent(languageJSON, "label_backside")}
                        constraints={{
                           audio: false,
                           video: {
                              facingMode: "environment",
                           },
                        }}
                        cameraStateChange={() => {}}
                        content={
                           <CustomButton
                              size="large"
                              variant="outlined"
                              style={{ textAlign: "center", width: "100%" }}
                              color="primary"
                              label={
                                 <Grid container alignItems="center" justify="center">
                                    <CameraAlt style={{ marginRight: 5 }} />
                                    <Typography style={{ fontSize: 12 }}>
                                       {getContent(
                                          languageJSON,
                                          proofCaptureBacksideMapping[selectedIdProofOption.value] ||
                                             PROOF_KEYS.CAPTURE_BACKSIDE_DL
                                       )}
                                    </Typography>
                                 </Grid>
                              }
                           />
                        }
                        captureImage={(image) => captureImage("idProofBackSide", image)}
                     />
                  </Grid>
               </Grid>
            ) : null}
         </Container>
      </div>
   );
};

export default IdProof;
